import React, { createContext, useReducer } from 'react';

// Context
const State = createContext();
const Dispatch = createContext();

// Reducer
const reducer = (state, action) => {
  switch (action.type) {
    case 'setTheme':
      return {
        ...state,
        theme: action.theme,
      };
    default:
      return state;
  }
};

// Provider
const Provider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, {
    theme: {
      backgroundColor: '#FFF',
      foregroundColor: '#000',
    },
  });

  return (
    <State.Provider value={state}>
      <Dispatch.Provider value={dispatch}>{children}</Dispatch.Provider>
    </State.Provider>
  );
};

export const GlobalState = {
  State,
  Dispatch,
  Provider,
};
